const linkedInPosterDanish = {
  messages: {
    connectionError: "Der opstod en fejl ved kontrol af dine forbindelser",
    codeGenerationError: "Der opstod en fejl ved generering af tilknytningskode. Prøv igen senere.",
    workflowTestSuccess: "LinkedIn post sendt via Telegram! Tjek din Telegram chat.",
    workflowTestError: "Fejl ved test af workflow. Tjek konsollen for detaljer.",
    linkedInDisconnectError: "Der opstod en fejl ved afkobling af LinkedIn: {message}",
    telegramDisconnectError: "Der opstod en fejl ved afkobling af Telegram: {message}",
    deliveryPreferenceError: "Der opstod en fejl ved opsætning af leveringspræference: {message}"
  }
};

export default linkedInPosterDanish; 